// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component
import ProductGrid from './PageComponent/ProductGrid';

function Products() {
  useMeta({
    title: 'Discover stunning array of Window Fashion where style meets luxury',
    description: 'We manufacture blinds having accuracy with variety of fabrics, designs and operating systems prioritizing commitment to quality and innovation',
    canonical: 'https://callistusblinds.com/product/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Discover stunning array of Window Fashion where style meets luxury',
      description:
        'We manufacture blinds having accuracy with variety of fabrics, designs and operating systems prioritizing commitment to quality and innovation',
      url: 'https://callistusblinds.com/product/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <ProductGrid />
      <Footer />
    </div>
  );
}

export default Products;
